import axios from 'axios';

export const postVaccinationResponse = (params) => {
	return axios.post('/TRAINServlet/Web2Train', null, {params:params });
};